module.exports = __webpack_public_path__ + "static/media/293884.fe7c584c.png";